/**
 * Library license type.
 */
export class LicenseType {
  public static readonly MIT = 'MIT License';
  public static readonly APACHE_2 = 'Apache License 2.0';
  public static readonly MPL_2 = 'Mozilla Public License 2.0';
  public static readonly BSD_2 = 'BBSD 2-Clause FreeBSD License';
  public static readonly BSD_3 = 'BSD 3-Clause Revised License';
  public static readonly ISC = 'Internet Systems Consortium (ISC) License';
  public static readonly LGPL_3 = 'GNU Lesser General Public License v3.0 only';
  public static readonly GLP_3 = 'GNU General Public License v3.0 only';
  public static readonly UNLICENSE = 'The Unlicense';
}
